export default "__VITE_ASSET__dAFT0Svb__"